import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-data-imp',
  templateUrl: './data-imp.component.html',
  styleUrls: ['./data-imp.component.css']
})
export class DataImpComponent implements OnInit {
    dataImpKeyno;

    public edit?: Edit;

    public dataImpNameButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'translateedit', gotoParms: () => this.edit!.word_id ?? '' }];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.dataImpKeyno = this.stateService.getStateParams()['dataimp_keyno'];
    }

    private async loadEdit() {
        if (!!this.dataImpKeyno) {
            this.edit = (await this.datatask.Post(3170, { dataimp_keyno: this.dataImpKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(3171, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    dataimp_keyno: string;
    reg_datetime: string;
    reg_by_portal_user_name: string;
    dataimp_name: string;
    table_name_destination: string;
    proc_name_fill: string;
    url_excel_template: string;
    word_id: string;
    proc_name_grid: string;
    main_destination_table_name: string;
    show_pricelist_id: string;
    show_language_id: string;
    show_prodgrp_id: string;
    show_prodtype_no: string;
    show_stockplace_id: string;
    show_datefomtom: string;
    show_searchtext: string;
}
